// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 7346 ? "aerosim" : chunkId) + "." + {"3630":"4b058fd6","7346":"fdcef6b9","7873":"24565726"}[chunkId] + ".chunk.css";
};